export default "__VITE_ASSET__CHFqC9rA__"